import {
  BrandedConfig,
  ENV_BRAND_NWB,
  ENV_BRAND_RBS,
  ENV_BRAND_UBN,
} from "services/envService";

// DONT WANT TO USE PAYG
export const DONT_WANT_TO_USE_PAYG_TOP_TEXT_1_1 =
  "You’ve indicated that you do not wish to make use of PAYG options. View information on all the support available to you";
export const DONT_WANT_TO_USE_PAYG_TOP_TEXT_1_2 = `where you will also be able to chat with one of our specialist team members or contact your Relationship Manager if you have one.`;

// CEASED TRADING
export const CEASED_TRADING_TOP_TEXT = `You’ve indicated that your business has formally (and permanently) ceased trading which means PAYG is not appropriate for your Bounce Back Loan. If you would like to discuss other repayment options for your Bounce Back Loan, please call your Relationship Manager, if you have one, or our Business Line on`;

// NOT AUTHORISED ATTESTATION
export const NOT_AUTHORISED_ATTESTATION_HEADER = `Alternative signatory required`;
export const NOT_AUTHORISED_ATTESTATION_MESSAGE = `You’ve indicated that you are either not authorised to act on behalf of the business or not over the age of 18 years. The online application can only be completed by individuals who are authorised to act on behalf of the business and are at least 18 years of age.`;

// CONTACT US
export const CONTACT_US_HEADER = "How to contact us";
export const CONTACT_US_TOP_TEXT =
  "You’ve indicated that you cannot, or would not like to, make use of your Pay as you Grow (PAYG) options or would like assistance. If you would like assistance, or to discuss whether PAYG is still available or what other options may be available to you, please call your Relationship Manager or our Business Line team on";

// VULNERABLE
export const CONTACT_US_TOP_TEXT_CLS_VUL = `You’ve indicated that you have a disability or personal circumstances that prevent you from using the online journey to access the PAYG options. If you would like to discuss what options may be available to you, please call your Relationship Manager, if you have one, or our Business Line team on`;

//COMPREHENSION
export const COMPREHENSION_TOP_TEXT = `You’ve indicated that you would like to discuss the PAYG options further and wish to discuss all the options and help available to you. Your Relationship Manager or a member of the team will call you back within 5 working days to discuss what options and help may be available to you. This may be from a withheld number.`;

//FINANCIAL DIFFICULTY
export const FINANCIAL_DIFFICULTY_TOP_TEXT = `You have indicated that your business is in financial difficulty and that you would like to talk to us about your circumstances. Your Relationship Manager or a member of the team will call you back within 5 working days to discuss what options and help may be available to you. This may be from a withheld number.`;
export const CONTACT_US_TEXT_1 =
  "to speak with one of our specialist team members.";
export const CONTACT_US_TEXT_2 = "If you are using Relay UK call";
export const CONTACT_US_TEXT_3 =
  "Calls may be recorded for training and monitoring purposes.";
export const CONTACT_US_TEXT_4 =
  "To find out how much your call might cost, see our";
export const CONTACT_US_TEXT_4_LINK_TEXT = "call charge information";

export const APPLICATION_CANCELLED_TEXT =
  "Please note that this online application has been cancelled.";
export const EXIT_BUTTON_TEXT = "Return to Bounce Back Loan support";

//BRAND SPECIFIC VALUES
export const BUSINESS_LINE_CODE = "0345";

export const BUSINESS_LINES: BrandedConfig = {
  [ENV_BRAND_NWB]: `${BUSINESS_LINE_CODE} 711 4477`,
  [ENV_BRAND_RBS]: `${BUSINESS_LINE_CODE} 600 2230`,
  [ENV_BRAND_UBN]: `${BUSINESS_LINE_CODE} 366 5592`,
};

export const RELAY_UK_CALL_CODE = "18001 ";

export const CALL_CHARGE_INF_LINKS: BrandedConfig = {
  [ENV_BRAND_NWB]: "https://supportcentre.natwest.com/913202582",
  [ENV_BRAND_RBS]: `https://www.supportcentre-rbs.co.uk/Searchable/913202582/Call-charge-information.htm`,
  [ENV_BRAND_UBN]:
    "https://digital.ulsterbank.co.uk/_shared-content-area/call-charges.html",
};

export const BOUNCE_BACK_LOAN_LINKS: BrandedConfig = {
  [ENV_BRAND_NWB]:
    "https://www.business.natwest.com/business/support-centre/service-status/coronavirus/understanding-your-bounce-back-loan.html",
  [ENV_BRAND_RBS]:
    "https://www.business.rbs.co.uk/business/support-centre/service-status/coronavirus/understanding-your-bounce-back-loan.html",
  [ENV_BRAND_UBN]:
    "https://digital.ulsterbank.co.uk/business/support/service-status/coronavirus/understanding-your-bounce-back-loan.html",
};

export const BOUNCE_BACK_FAQ_LINKS: BrandedConfig = {
  [ENV_BRAND_NWB]: `https://www.business.natwest.com/business/support-centre/service-status/coronavirus/bounce-back-loan/bounce-back-loan-support.html#payg`,
  [ENV_BRAND_RBS]: `https://www.business.rbs.co.uk/business/support-centre/service-status/coronavirus/bounce-back-loan/bounce-back-loan-support.html#payg`,
  [ENV_BRAND_UBN]: `https://digital.ulsterbank.co.uk/business/support/service-status/coronavirus/bounce-back-loan/bounce-back-loan-support.html`,
};
